export default __webpack_public_path__ + "static/Content-2-186c026ec62d9012992ca842ef08ad42.webm";